module.exports = "/_next/static/images/background-a64edb470e9c1253ccdc8b0b92e25efe.svg";